var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"perfil-picture-uploader"},[_c('picture-input',{ref:"pictureInput",attrs:{"width":"600","height":"600","margin":"16","accept":"image/*","size":"10","button-class":"btn btn-primary","removeButtonClass":"btn btn-black btn-borderless","radius":"50","crop":true,"prefill":_vm.photo,"hideChangeButton":false,"autoToggleAspectRatio":true,"toggleAspectRatio":true,"removable":false,"custom-strings":{
                upload: 'Cambiar',
                change: 'Cambiar',
                remove: 'Quitar',
                drag: 'Cambiar',
                select: 'Seleccionar', // Text only
                selected: '<p>Photo successfully selected!</p>', // HTML allowed
                fileSize: 'The file size exceeds the limit', // Text only
                fileType: 'This file type is not supported.', // Text only
                aspect: 'Landscape/Portrait' // Text only

            }},on:{"change":_vm.onChange}}),(_vm.didChange)?_c('button',{staticClass:"btn btn-primary perfil-picture-uploader-save",on:{"click":_vm.emitSave}},[_vm._v("\n                Guardar\n            ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }